import axiosClient from './apiClient';

export const getBestSellerById = (id: string, data: any) => {
  return axiosClient.post(`/api/v2/product/bestseller/${id}`, data);
};
